// After a masked input re-formats its value the browser drops the caret at the
// end. These helpers put it back after the same number of significant
// characters (digits, or digits+'.' for cents) it followed before.

// Count of chars matching `keep` in str[0:caret].
export function countBefore(str, caret, keep = /\d/) {
  let n = 0;
  for (let i = 0; i < Math.min(caret, str.length); i++) if (keep.test(str[i])) n += 1;
  return n;
}

// Index just after the n-th `keep` char in `formatted`; 0 when n <= 0; length when fewer.
export function caretAfterNth(formatted, n, keep = /\d/) {
  if (n <= 0) return 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (keep.test(formatted[i])) { seen += 1; if (seen === n) return i + 1; }
  }
  return formatted.length;
}

// Backspace/delete over a *formatting* char (')', ' ', '-', ',', '$') removes no
// significant char, so the naive re-format would put the char straight back and
// the key would look dead. Detect that case (value got shorter, significant
// chars unchanged) and remove the significant char immediately left of the caret.
// Returns { sig, before }: the new significant-char string and how many of them
// sit left of the caret (for caretAfterNth).
export function afterEdit(prevFormatted, nextRaw, caret, keep = /\d/) {
  const strip = (s) => Array.from(String(s)).filter((c) => keep.test(c)).join('');
  const prevSig = strip(prevFormatted);
  const nextSig = strip(nextRaw);
  const before = countBefore(nextRaw, caret, keep);
  // Exactly one char shorter — a single Backspace/Delete keystroke. A larger
  // drop (e.g. pasting '512.555.0101' over '(512) 555-0101') can coincidentally
  // have the same significant-char content at a shorter length; that's a
  // replace, not a formatting-char backspace, so it must not trigger this path.
  if (prevFormatted.length - nextRaw.length === 1 && nextSig === prevSig && prevSig.length > 0 && before > 0) {
    const left = strip(nextRaw.slice(0, caret)).slice(0, -1);
    const right = strip(nextRaw.slice(caret));
    return { sig: left + right, before: before - 1 };
  }
  return { sig: nextSig, before };
}
